module.exports = __webpack_public_path__ + "img/t3-endorsement-list.9e51331b.png";